import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
import * as XLSX from 'xlsx';
import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from "../../../signal/allUsersSignal";
import AddDealerModal from "./AddDealerModal";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import Select from "react-select";


export default function DealersList() {

    const [searchParams, setSearchParams] = useSearchParams();
    const fileInputRef = useRef(null);
    const [dealers, setDealers] = useState([]);
    const [dealersToDisplay, setDealersToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    const [showAddDealerModal, setShowAddDealerModal] = useState(false);
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(35);
    const [totalItems, setTotalItems] = useState(0);
    const [userId, setUserId] = useState(searchParams.get("userId") ? searchParams.get("userId") : "");

    const navigate = useNavigate();

    // useEffect(() => {
    //     setDealersToDisplay(dealers.filter((item) => {
    //         if (search === "") return true;
    //         if (item?.name?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.gstin?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.phoneNumber?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.address?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.city?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.state?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.pincode?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.email?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.website?.toLowerCase().includes(search.toLowerCase())) return true;
    //         let user = allUsersSignal.value[item.userId];
    //         if (user) {
    //             if (user.name.toLowerCase().includes(search.toLowerCase())) return true;
    //         }
    //         if (moment(item.createdAt).format("DD/MM/YY hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;

    //         return false;
    //     }))
    // }, [search, dealers])

    const getDealers = useQuery("dealers", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/dealer/v2/dashboard?page=${page}&perPage=${perPage}&search=${search}&userId=${userId}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setDealers(data.data?.dealers || []);
                setPage(data.data?.page || 1);
                setPerPage(data.data?.perPage || 35);
                setTotalItems(data.data?.totalItems || 0);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const refetchDealers = () => {
        getDealers.refetch({ cancelRefetch: true });

    }

    const delaerDeleteMutation = useMutation((body) => axios.delete(`${DEV_SERVER}/dealer/v2/${body.id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success("Dealer deleted successfully")
                refetchDealers()
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })


    const handleDownloadTemplate = () => {
        // Create template data with headers only
        const template = [
            {
                'name *': '',
                'phoneno *': '',
                email: '',
                gst: '',
                'address *': '',
                city: '',
                state: '',
                pincode: '',
                aboutparty: ''
            }
        ];

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(template);

        // Set column widths
        worksheet['!cols'] = [
            { wch: 20 }, // name
            { wch: 15 }, // phoneno
            { wch: 30 }, // email
            { wch: 20 }, // gst
            { wch: 40 }, // address
            { wch: 20 }, // city
            { wch: 20 }, // state
            { wch: 12 }, // pincode
            { wch: 40 }  // aboutparty
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

        // Download file
        XLSX.writeFile(workbook, 'Product_Template.xlsx');
        toast.success('Template downloaded successfully');
    };

    const handleImportExcel = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convert sheet to JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

                if (jsonData.length === 0) {
                    toast.error('Excel file is empty');
                    return;
                }

                // Map Dealer data - import all records
                const dealers = jsonData
                    .map(row => ({
                        name: (row['name *'] || row.name)?.toString().trim() || '',
                        phoneNumber: (row['phoneno *'] || row.phoneno) ? parseInt((row['phoneno *'] || row.phoneno)?.toString().trim()) : undefined,
                        email: row.email?.toString().trim() || '',
                        gstin: row.gst?.toString().trim() || '',
                        address: (row['address *'] || row.address)?.toString().trim() || '',
                        city: row.city?.toString().trim() || '',
                        state: row.state?.toString().trim() || '',
                        pincode: row.pincode ? parseInt(row.pincode?.toString().trim()) : undefined,
                        aboutParty: row.aboutparty?.toString().trim() || ''
                    }));

                if (dealers.length === 0) {
                    toast.error('No valid records found in Excel');
                    return;
                }

                toast.info(`Importing ${dealers.length} dealer(s)...`);

                const totalRows = jsonData.length;
                const skippedCount = 0;
                let successCount = 0;
                let failCount = 0;

                for (const dealer of dealers) {
                    try {
                        const response = await axios.post(
                            `${DEV_SERVER}/dealer/v2`,
                            dealer,
                            {
                                headers: {
                                    Authorization: `Bearer ${userSignal.value?.token}`,
                                },
                            }
                        );

                        if (response.data?.status) {
                            successCount++;
                        } else {
                            failCount++;
                            console.error('Failed:', dealer.name, response.data?.message);
                        }
                    } catch (error) {
                        failCount++;
                        console.error('API Error:', dealer.name, error);
                    }
                }

                // Result Toasts
                if (successCount > 0) {
                    toast.success(`Successfully imported ${successCount} dealer(s)`);
                    refetchDealers();
                }
                if (failCount > 0) {
                    toast.warning(`Failed to import ${failCount} dealer(s)`);
                }

            } catch (error) {
                toast.error('Failed to read Excel file');
                console.error(error);
            }
        };

        reader.readAsArrayBuffer(file);

        // Reset file input
        event.target.value = '';
    };


    const handleDealerDelete = (id) => {

        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this dealer?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        delaerDeleteMutation.mutate({ id: id })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ],
            overlayClassName: "overlay-custom-confirm-alert",
        });


    }

    useEffect(() => {
        refetchDealers();


    }, [page, perPage, search])

    const handleFilters = async () => {

        const tempSearchParam = new URLSearchParams({ userId: userId })
        setSearchParams(tempSearchParam);

        await refetchDealers();
    }

    const columns = [
        {
            name: "Name",
            color: true,
            center: true,
            selector: (row) => {
                const displayName = row?.name && row?.name !== "" ? row?.name : "-";
                return <OverlayTrigger placement="top" overlay={
                    <Tooltip style={{ position: "fixed" }}>
                        {displayName}
                    </Tooltip>
                }>
                    <span>{displayName}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Phone Number",
            color: true,
            center: true,
            selector: (row) => row?.phoneNumber || "-",
        },
        {
            name: "GSTIN",
            color: true,
            center: true,
            selector: "gstin",
            sortable: true,
        },
        {
            name: "Address",
            color: true,
            center: true,
            width: "200px",
            selector: (row) => {
                const fullAddress = `${row?.address || ''}, ${row?.city || ''}, ${row?.state || ''}, ${row?.pincode || ''}`.replace(/(^,\s*|,\s*$|,\s*,)/g, '').trim();
                const displayAddress = row?.address && row?.address !== "" ? row?.address : "-";
                const hasFullAddress = fullAddress && fullAddress !== "";
                
                return hasFullAddress ? (
                    <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }}>
                            {fullAddress}
                        </Tooltip>
                    }>
                        <span>{displayAddress}</span>
                    </OverlayTrigger>
                ) : <span>{displayAddress}</span>
            },
            sortable: true,
        }, {
            name: "Group",
            selector: 'group',
            center: true
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap", }}>
                {(row?.visitingCard?.length && row?.visitingCard?.length > 0) && row?.visitingCard?.map((m) =>
                    <>
                        <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px", pointerEvents: "none" }} /></Zoom>
                    </>
                )}
            </div>
        },
        {
            name: "Added by",
            color: true,
            selector: (row) => {
                let user = allUsersSignal.value[row?.userId];
                if (user) {
                    return <span style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                        <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={user.profileURL !== "" ? user.profileURL : avatar1} />
                        {user.name}
                    </span>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Updated At",
            color: true,
            center: true,
            sortable: true,
            selector: "updatedAt",
            cell: (row) => {
                return moment(row?.updatedAt).format("DD/MM/YY hh:mm A")
            }
        },
        {
            name: "Location",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.location?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.location[0]},${row?.location[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Action",
            center: true,
            selector: (row) => {
                return <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            setSelectedDealer(row);
                            setShowAddDealerModal(true);
                        }}><i className="far fa-edit table-icons"></i></span>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            handleDealerDelete(row?.id)
                        }}><i className="far fa-trash-alt table-icons"></i></span>
                    </OverlayTrigger>
                </div>
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Dealers List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>

                                <Accordion className="mb-3">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="maxAmount">User</label>
                                                    <Select
                                                        options={Object.keys(allUsersSignal?.value).map((key) => {
                                                            return { value: allUsersSignal?.value[key].id, label: allUsersSignal?.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setUserId(e.value);
                                                            } else {
                                                                setUserId("");
                                                            }
                                                        }}

                                                        value={allUsersSignal?.value[userId] ? { value: allUsersSignal?.value[userId].id, label: allUsersSignal?.value[userId].name } : null}

                                                        isClearable
                                                    />
                                                </div>



                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setUserId("");
                                                    const tempSearchParam = new URLSearchParams({ userId: "" });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>

                                <div style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem", justifyContent: "space-between" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                    <div style={{ display: "flex", columnGap: "0.5rem" }}>
                                        <button className="btn btn-outline-primary" onClick={handleDownloadTemplate} >
                                            <i className="fas fa-download"></i>
                                            <span className="ms-1">Download Template</span>
                                        </button>

                                        <button className="btn btn-outline-success" onClick={() => fileInputRef.current?.click()}>
                                            <i className="fas fa-file-excel"></i>
                                            <span className="ms-1">Import Excel</span>
                                        </button>

                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            accept=".xlsx, .xls"
                                            onChange={handleImportExcel}
                                        />

                                        <button onClick={() => setShowAddDealerModal(true)} className="btn btn-primary">
                                            <i className="fas fa-plus"></i>
                                            <span className="ms-1">Add Dealer</span>
                                        </button>
                                    </div>
                                </div>
                                {(!getDealers.isLoading && !getDealers?.isFetching) &&
                                    <DataTable
                                        columns={columns} data={dealers} pagination={true}
                                        onRowClicked={(row) => navigate(`/dashboard/dealers/${row?.id}`)}
                                        paginationServer={true} paginationTotalRows={totalItems} paginationPerPage={perPage} paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                        paginationDefaultPage={page}
                                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                            setPerPage(currentRowsPerPage);
                                        }
                                        } onChangePage={(currentPage) => {
                                            setPage(currentPage);
                                        }}
                                        customStyles={
                                            {
                                                cells: "center",
                                                rows: {
                                                    style: {
                                                        cursor: "pointer",
                                                        backgroundColor: "unset"
                                                    }
                                                }
                                            }
                                        }
                                    />}
                                {(getDealers.isLoading || getDealers?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showAddDealerModal && <AddDealerModal dealer={selectedDealer} close={() => {
                setShowAddDealerModal(false)
                setSelectedDealer(null)
            }} show={showAddDealerModal} refetchDealers={refetchDealers} />}
        </>
    )
}